import PushNotificationActionCreator from "@/helpers/push/creators/PushNotificationActionCreator";
import DefaultAction from "@/helpers/push/actions/DefaultAction";
export default class DefaultActionCreator extends PushNotificationActionCreator {
    action;
    constructor() {
        super();
        this.action = 'Default Action';
    }
    create() {
        return new DefaultAction(this.action);
    }
}
